import axiosConfig from "../../../../config/axiosConfig";
import { PIECE_PART_URL } from "../../../../config/config";
import { getFmvValue } from "../../../../data/data";
import {
  createQueryParams,
  getStringFromArray,
} from "../../../../utils/helper";

export const GetPiecePartService = (params) => {
  const {
    page,
    per_page,
    threshold,
    tiers,
    from_date,
    to_date,
    order_by,
    qty_available,
    status,
    ata_chapter,
    serial_number,
    pn_type,
    pn,
    description,
    // stm_unit_cost,
    rec_date,
    stock_visible,
    dynamic_cat,
    msn_esn,
    full_dynamic_cat,
    application_code,
    fair_market_value,
    fmv,
    fmv_operator,
    fmv_value,
    fmv_start,
    fmv_end,
    condition_code,
  } = params;

  // Construct the params object dynamically
  const paramsList = {
    page,
    per_page,
    threshold,
    part_tier: tiers,
    from_date,
    to_date,
    order_by,
    qty_available: qty_available?.value,
    status,
    ata_chapter,
    serial_number,
    pn_type: getStringFromArray(pn_type),
    pn,
    description: description,
    // stm_unit_cost,
    rec_date,
    stock_visible,
    dynamic_cat,
    full_dynamic_cat,
    application_code: application_code?.value,
    fair_market_value,
    fmv,
    fmv_operator: fmv_operator?.value,
    fmv_value,
    fmv_start,
    fmv_end,
    msn_esn,
    condition_code: getStringFromArray(condition_code),
    dynamic_filters: fmv_operator?.value
      ? {
          suggested_fmv_with_vq: fmv_operator?.value
            ? {
                operator: fmv_operator?.value,
                value: getFmvValue({
                  fmv_operator: fmv_operator?.value,
                  fmv_value,
                  fmv_start,
                  fmv_end,
                }),
              }
            : undefined,
        }
      : undefined,
  };

  // Remove any parameters that are undefined or null
  const filteredParams = Object.fromEntries(
    Object.entries(paramsList).filter(([_, v]) => v != null)
  );

  // Assuming createQueryParams is a function that turns an object into a query string
  const queryString = createQueryParams(filteredParams);
  const url = `${PIECE_PART_URL}${queryString ? `?${queryString}` : ""}`;
  // Return axios GET request
  return axiosConfig.get(url);
};
